import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import { I18n } from "aws-amplify/utils";
import { APIStatusDialog } from "components/APIStatusDialog";
import { tlmPostAccountNumberActive } from "layouts/dashboard/apiService";

const ActivateStoreDialog = ({ open, onClose, accountNumber, setStoreStatus, onCloseNote }) => {
  const [apiStatus, setApiStatus] = useState({
    open: false,
    status: "",
    message: "",
  });

  const handleActivate = async () => {
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Store Reactivation"),
      });

      const restOperation = await tlmPostAccountNumberActive(accountNumber);
      const response = await restOperation.response;

      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Store successfully reactivated"),
        });
        setStoreStatus("active");
        onCloseNote();
        onClose();
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Failed to reactivate store"),
        });
      }
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Failed to reactivate store"),
      });
    } finally {
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
       <DialogContent>
        {I18n.get("Are you sure you want to reactivate this store?")}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleActivate} color="primary">
          {I18n.get("Confirm")}
        </Button>
        <Button onClick={onClose}>{I18n.get("Cancel")}</Button>
      </DialogActions>
      <APIStatusDialog
        open={apiStatus.open}
        status={apiStatus.status}
        message={apiStatus.message}
      />
    </Dialog>
  );
};

export default ActivateStoreDialog;
